import React from "react";

// PropertyMakers rooftops monogram — an interim, original SVG interpretation of
// the client logo's skyline motif (a row of pitched roofs). Renders crisp at any
// size inside a square viewBox so it drops into badges/tiles cleanly.
//
// `navy` fills the roofs, `gold` the baseline accent. Swap for the final logo
// artwork by setting BRAND.useImageMark and referencing the PNG in <Logo>.
export function PropertyMakersMark({
    size = 32,
    navy = "#2C4A87",
    gold = "#B7975A",
    className = "",
    title = "PropertyMakers",
}) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label={title}
            className={className}
        >
            {/* three pitched rooftops, descending — the skyline from the wordmark */}
            <path d="M32 14 L48 27 L48 34 L32 21 L16 34 L16 27 Z" fill={navy} />
            <path d="M20 30 L32 39 L44 30 L44 46 L20 46 Z" fill={navy} opacity="0.92" />
            {/* a lit window */}
            <rect x="29" y="40" width="6" height="6" rx="1" fill="#FFFFFF" />
            {/* gold ground line */}
            <rect x="14" y="49" width="36" height="3" rx="1.5" fill={gold} />
        </svg>
    );
}
